import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { UndoRedo } from '../topbar/UndoRedo';
import { showcaseMessages } from './showcaseMessages';
import { ShowcaseSignUpLink } from './ShowcaseSignUpLink';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import editorStyles from '../MusicVideoEditor.module.scss';
import styles from './MusicVideoShowcase.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The top bar of the showcase on a phone (design c5): "Demo", the song, Undo, Redo, "Sign up free". */
const ShowcasePhoneTopComponent: React.FC = () => {
  const intl = useIntl();
  const { data } = useMusicVideoEditor();
  return (
    <header className={editorStyles.phoneTop}>
      <span className={styles.demoChip}>{intl.formatMessage(showcaseMessages.demoChip)}</span>
      <div className={editorStyles.column}>
        <b>{data.song.title}</b>
        <small>{intl.formatMessage(showcaseMessages.phoneSongLine, { artist: data.song.artistName })}</small>
      </div>
      <span className={editorStyles.grow} />
      <UndoRedo />
      <ShowcaseSignUpLink place="topBar">{intl.formatMessage(showcaseMessages.signUpFree)}</ShowcaseSignUpLink>
    </header>
  );
};

export const ShowcasePhoneTop = TypedMemo(ShowcasePhoneTopComponent);
